import React, { useState, useEffect } from 'react';
import ButtonBack from './images/x.png';
import Info from './images/Icon_Info.png';
import useSolanaWeb3 from '../hooks/useSolanaWeb3';
import { toast } from 'react-hot-toast';

  function AntInfoPopup({ onClose, antInfo, levelingPotionBalance }) {

  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(0);
  const [newLevel, setNewLevel] = useState(antInfo.level || 1);
  const { upgradeAntLevelWithLevelingPotion } = useSolanaWeb3();

  const absoluteMaxPotions = 820;
  // Determine the max potions user can use, which is the lesser of their balance or the absolute maximum
  const maxPotions = Math.min(levelingPotionBalance, absoluteMaxPotions);

  const handleIncrement = () => {
    if (value < levelingPotionBalance) {
      setValue((prev) => prev + 1)
    }
  };

  const handleDecrement = () => {
    if (value > 0) {
      setValue((prevValue) => prevValue - 1);
    }
  }

  const handleInputChange = (e) => {
    let inputValue = Number(e.target.value);
    if (inputValue > maxPotions) {
      inputValue = maxPotions; // Reset to maxPotions if input exceeds the allowed maximum
      // Optional: Show a notification or feedback to the user here
    }
    setValue(inputValue);
  };

  const getNewLevel = (experience) => {
    let level = Math.floor(Math.sqrt(2 * experience));
    while ((level * (level + 1)) / 2 > experience) {
      level--;
    }
    return level;
  }

  const upgradeAntLevel = async() => {
    setLoading(true); // Start loading before the operation
    try {
      console.log(antInfo.mint, value);
      await upgradeAntLevelWithLevelingPotion(antInfo.mint, value);
      // Assuming the transaction is successful if no errors were thrown
      toast.success("Potion used successfully. Ant level upgraded!");
    } catch (error) {
      console.error(error);
      // Here you might want to check the specific error messages
      // and customize the toast error message accordingly
      toast.error("Failed to use potions. Please try again.");
    } finally {
      setLoading(false); // Stop loading after the operation
    }
  };

  useEffect(() => {
    // Start by calculating the cumulative experience required to reach the current level
    let initialExp = 0;
    let expNeeded = 3; // Experience needed to reach the next level, starting from level 1 to 2
    for (let level = 2; level <= antInfo.state.level; level++) {
      initialExp += expNeeded;
      // Increment the EXP required for the next level after reaching level 3
      if (level > 2) {
        expNeeded++;
      }
    }
  
    // Calculate total experience available including remainPotions and value
    const totalExp = initialExp + value + antInfo.state.remainPotions;
  
    // Now calculate the new level based on total experience
    let calculatedLevel = 1;
    let cumulativeExp = 0;
    expNeeded = 3; // Reset for calculating new level
    while (cumulativeExp + expNeeded <= totalExp) {
      cumulativeExp += expNeeded;
      calculatedLevel++;
      if (calculatedLevel > 2) {
        expNeeded++;
      }
    }
  
    setNewLevel(calculatedLevel);
  }, [value, antInfo.state.level, antInfo.state.remainPotions]);

  return (
    <div className="popup-container">
      <div className="popup" id="shoppopup">
        <button className="button-close" onClick={onClose}>
          <img src={ButtonBack} alt="Close button" />
        </button>
        <div className="popup-content-left">
          <div className="popupimage-holder" id="antinfo-image-holder">
            <img src={antInfo.metadata.image} alt="ANT" />
          </div>
          <div className="popup-infoholder">
          <h2>WORKER ANT</h2>
          <p>Basic ant</p>
          <div className="active-item-ant-container2">
          <div className="active-item-stats"><h3>LVL: {antInfo.state.level}</h3></div>
          <div className="active-item-stats"><h3>EXP: {antInfo.state.remainPotions}</h3></div>
          </div></div>
        </div>
        <div className="popup-content-right">
          <div className="popupinfo-holder" id="potion-use-info">
            <div className="info-box" id="potion-info-box">
              <h2>USE POTIONS</h2>
              <p>Potions Balance: {levelingPotionBalance}</p>
            </div>
            <div className="amount-box">
              <button onClick={handleDecrement}>-</button>
              <input
                type="number"
                value={value}
                max={maxPotions}
                onChange={handleInputChange}
              />
              <button onClick={handleIncrement}>+</button>
            </div>
            <div className="counter" id="newlevel-counter">
              <h3>NEW LVL:</h3>
              <h3>{newLevel}</h3>
            </div>
            <div className="counter" id="usagefee-counter">
              <p>Usage Fee:</p>
              <p>{(value * (antInfo.antType === "PREMIUM" ? 2 : 5))} $ANTC</p> 
            </div>
            <button className="buy-button" id="use-potions-button" disabled={loading} onClick={()=>upgradeAntLevel()}>
              <span>{loading ? "Loading..." : "USE POTIONS"}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AntInfoPopup;